import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const yearlyReportsManagement = createApi({
    reducerPath: "yearlyReportsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        yearlyReportsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/yearly-reports`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewYearlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/yearly-reports/${reportId}`,
                method: "GET",
            }),
        }),

        addYearlyReports: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/yearly-reports`,
                method: "POST",
                body: body,
            }),
        }),

        updateYearlyReports: builder.mutation({
            query: ({ body, reportId }) => ({
                url: `v1/${locale}/settings/yearly-reports/${reportId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteYearlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/yearly-reports/${reportId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useYearlyReportsListMutation,
    useDeleteYearlyReportsMutation,
    useAddYearlyReportsMutation,
    useViewYearlyReportsMutation,
    useUpdateYearlyReportsMutation,
} = yearlyReportsManagement;
